import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Typography from "@mui/material/Typography";
import Toolbar from "@mui/material/Toolbar";
import { styled, ListItem, ListItemText } from "@mui/material";

export const AppBarStyled = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  boxShadow: "none",
  backgroundColor: "#ffffff",
  borderBottom: "2px solid #E2E8F0",
  outline: "none",
  zIndex: theme.zIndex.drawer - 1,
  width: "100%",
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - 245px)`,
    marginLeft: `245px`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
  [theme.breakpoints.down('md')]: {
    width: "100%",
    marginLeft: 0,
  }
}));

export const ProfileContainer = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: "32px",
  backgroundColor: "#FFFFFF",
  marginLeft: theme.spacing(0),
  width: "auto",
  minWidth: "160px",
  height: "42px",
  display: "flex",
  alignItems: "center",
  border: "0.6px solid #B9C7E4",
  boxShadow: "0px 2px 7px 0px #B4C0D9",
  overflow: "hidden",
  [theme.breakpoints.down('md')]: {
    minWidth: "42px",  // Just enough for the avatar
    '& > div': {  // This targets the Box with text
      display: 'none'
    }
  }
}));

export const DrawerHeader = styled("div")(({ theme }) => ({
  marginTop: "1px",
  padding: "6px",
  display: "flex",
  alignItems: "center",
  cursor:"pointer",
  justifyContent: "center",
  ...theme.mixins.toolbar,
  "&:hover": {
    backgroundColor: theme.palette.action.hover, // Uses theme's hover color
  },
}));

export const FlexContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  marginLeft: "auto",
  gap: "10px",
});

export const MainBox = styled(Box)({
  // backgroundColor: "#F3F7FF",
  minHeight: "100vh",
  borderWidth: "10px",
  borderColor: "#C4D1EB",
  borderRadius: "10px",
});

export const DrawerStyled = styled(Drawer)({
  width: "245px",
  flexShrink: 0,
  // backgroundColor: "#F3F7FF",
  "& .MuiDrawer-paper": {
    width: "245px",
    height: "94%",
    boxSizing: "border-box",
    flexDirection: "column",
    display: "flex",
    justifyContent: "space-between",
    // marginTop: "1%",
    // marginLeft: "1%",
    borderRadius: "24px",
    boxShadow: "0px 4px 4px 0px #CCD4E5",
    overflow: "auto",
  },
});

export const ProfileName = styled(Typography)({
  fontFamily: "Raleway",
  fontSize: "15px",
  fontWeight: 700,
  lineHeight: "17px",
  textAlign: "left",
  color: "#404040",
  marginRight: "12px",
  marginLeft: "8px",
  marginBottom: "3px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  maxWidth: "250px",
});

export const ProfileTitle = styled(Typography)({
  fontFamily: "Raleway",
  fontSize: "11px",
  fontWeight: 500,
  lineHeight: "13px",
  textAlign: "left",
  marginLeft: "8px",
  color: "#565656",
});

export const ToolbarStyled = styled(Toolbar)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
});

export const ListItemStyled = styled(ListItem)({
  padding: "8px 12px", 
  marginBottom: "8px", 
  borderRadius: "8px", 
  "&.Mui-selected": {
    backgroundColor: "#0068F7", 
    boxShadow: "0px 2px 8px 1px #0068F780", // Reduced box-shadow when selected
    color: "white", 
    borderLeft: "4px solid #0068F7",
    width : "94%",
    "& .MuiListItemIcon-root": {
      color: "white", 
    },
  },
  "&.Mui-selected:hover": {
    backgroundColor: "#0068F7", // Ensures the same background on hover when selected
    boxShadow: "0px 2px 8px 1px #0068F780", // Keeps reduced box-shadow on hover when selected
  },
  "&:hover": {
    backgroundColor: "#F9F9F9", 
  },
  "&:last-child": {
    marginBottom: "0px", 
  },
});
  
export const ListItemTextStyled = styled(ListItemText)({
  fontFamily: "Raleway",
  fontSize: "20px",
  fontWeight: 500,
  lineHeight: "16.44px",
  letterSpacing: "0.3px",
  textAlign: "left",
  width: "125px" , // Sets the width of the text container
  margin : "10px 0",
});